import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Link, Navigate, redirect } from "react-router-dom";
import {
  Autocomplete,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  TextareaAutosize,
} from "@mui/material";
// import Textarea from "@mui/joy/Textarea";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const fd = new FormData();
export default class UpdateCourses extends Component {
  state = {
    message: "",
    notification: false,
    course_name: "",
    duration: "",
    course_mode: "offline",
    price: "",
    description: "",
    course_image: {},
    rating: "",
    loading: false,
    redirect: false,
    image_preview: "",
    course_type: "abacus",
  };

  componentDidMount() {
    this.getSingleCourse();
  }

  getSingleCourse = () => {
    if (init() === "success") {
      const id = window.location.pathname.split("/")[2];
      axios
        .get(Constants.getUrls.getAllCourses + "/" + id)
        .then((resp) => {
          const data = resp.data?.data ?? resp.data;
          this.setState({
            course_name: data.course_name || "",
            duration: data.duration || "",
            course_mode: data.course_mode || "offline",
            course_type: data.course_type,
            price: data.price !== undefined ? data.price : "",
            description: data.description || "",
            rating: data.rating !== undefined ? data.rating : "",
            image_preview: data.image || "",
          });
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err?.response?.data?.message || "Error fetching course",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({
        course_image: file,
        image_preview: URL.createObjectURL(file),
      });
    }
  };

  handleDescription = (content) => {
    this.setState({ description: content });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    // clear previous FormData entries to avoid duplicates
    // rebuild fd fresh by creating a new FormData (but keeping pattern - we'll reset global fd)
    // NOTE: we recreate global fd reference here to mimic original pattern but ensure it's fresh
    // eslint-disable-next-line no-global-assign
    // fd = new FormData();

    fd.append("course_name", this.state.course_name);
    fd.append("duration", this.state.duration);
    fd.append("course_mode", this.state.course_mode);
    fd.append("course_type", this.state.course_type);
    fd.append("price", this.state.price);
    fd.append("description", this.state.description);
    if (this.state.course_image && this.state.course_image.name) {
      fd.append("course_image", this.state.course_image);
    }
    fd.append("rating", this.state.rating);

    if (init() === "success") {
      const id = window.location.pathname.split("/")[2];
      axios
        .put(Constants.putUrls.updateCourses + id, fd)
        .then((resp) => {
          this.setState({
            notification: true,
            message: resp.data.message || "Course updated",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "", redirect: true });
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err.response?.data?.message || "Something went wrong!",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 5000);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/courses" />;
    } else {
      return (
        <div>
          <div>
            <DashboardLayout>
              <DashboardNavbar />
              <MDBox pt={6} pb={3}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Update Course
                    </MDTypography>
                  </MDBox>

                  <MDBox py={3} px={2}>
                    <form onSubmit={this.handleSubmit}>
                      <Grid container sm={12} spacing={2}>
                        <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Course Name"
                            name="course_name"
                            onChange={this.handleInput}
                            value={this.state.course_name}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>

                        <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Duration"
                            name="duration"
                            onChange={this.handleInput}
                            value={this.state.duration}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>

                        <Grid item sm={4}>
                          <InputLabel>Select Course Mode</InputLabel>
                          <Select
                            onChange={(e) => this.setState({ course_mode: e.target.value })}
                            name="course_mode"
                            required
                            style={{ width: "100%", height: "45px", color: "#111" }}
                            value={this.state.course_mode}
                          >
                            <MenuItem value="">Select Course Mode</MenuItem>
                            <MenuItem value="online" style={{ color: "#111" }}>
                              Online
                            </MenuItem>
                            <MenuItem value="offline" style={{ color: "#111" }}>
                              Offline
                            </MenuItem>
                            <MenuItem value="hybrid" style={{ color: "#111" }}>
                              Hybrid
                            </MenuItem>
                          </Select>
                        </Grid>

                        <Grid item sm={4}>
                          <InputLabel>Select Course Tyoe</InputLabel>
                          <Select
                            value={this.state.course_type}
                            onChange={(e) => this.setState({ course_type: e.target.value })}
                            name="course_type"
                            required
                            fullWidth
                            style={{ height: "45px", color: "#111" }}
                          >
                            <MenuItem value="abacus">Abacus</MenuItem>
                            <MenuItem value="kalfun">Kalfun</MenuItem>
                            <MenuItem value="vedic_maths">Vedic Maths</MenuItem>
                          </Select>
                        </Grid>

                        <Grid item sm={4}>
                          <TextField
                            type="number"
                            label="Price"
                            name="price"
                            onChange={this.handleInput}
                            value={this.state.price}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>

                        <Grid item sm={4}>
                          <TextField
                            type="number"
                            label="Rating (0-5)"
                            name="rating"
                            onChange={this.handleInput}
                            value={this.state.rating}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>

                        <Grid item sm={6}>
                          <TextField
                            type="file"
                            label="Course Image"
                            name="course_image"
                            focused
                            onChange={this.handleFile}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>

                        {this.state.image_preview ? (
                          <Grid item sm={6} style={{ display: "flex", alignItems: "center" }}>
                            <img
                              src={Constants.imageDomain + this.state.image_preview}
                              alt="preview"
                              style={{ maxWidth: "100%", maxHeight: 120, objectFit: "contain" }}
                            />
                          </Grid>
                        ) : null}

                        <Grid item sm={12}>
                          <SunEditor
                            setDefaultStyle="font-family: Arial; font-size: 16px;"
                            setOptions={{
                              buttonList: [
                                ["undo", "redo"],
                                ["font", "fontSize"],
                                ["paragraphStyle", "blockquote"],
                                [
                                  "bold",
                                  "underline",
                                  "italic",
                                  "strike",
                                  "subscript",
                                  "superscript",
                                ],
                                ["fontColor", "hiliteColor"],
                                ["align", "list", "lineHeight"],
                                ["outdent", "indent"],
                                ["table", "horizontalRule", "link", "image", "video"],
                                ["imageGallery"],
                                ["preview", "print"],
                                ["removeFormat"],
                              ],
                              defaultTag: "div",
                              height: 120,
                              showPathLabel: false,
                            }}
                            name="description"
                            setContents={this.state.description}
                            onChange={this.handleDescription}
                          />
                        </Grid>
                      </Grid>

                      <Grid align="left" mt={2}>
                        <MDButton variant="contained" size="small" color="info" type="submit">
                          {this.state.loading ? "Updating..." : "Update"}
                        </MDButton>
                      </Grid>
                    </form>
                  </MDBox>
                  <>
                    <MDSnackbar
                      color="success"
                      icon="notifications"
                      title="Courses Admin"
                      content={this.state.message}
                      dateTime="Just now"
                      open={this.state.notification}
                    />
                  </>
                </Card>
              </MDBox>
            </DashboardLayout>
          </div>
        </div>
      );
    }
  }
}
